import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleStatusLogModel from "@/models/lab/SampleStatusLogModel";

export default class SampleStatusLogCollection extends LabServiceCollection {
  model() {
    return SampleStatusLogModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    
    return CollectionFilter;
  }

}
